import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ForgotUsernameView from './views/ForgotUsernameView';
import { submitAsyncEmailAction, resetStageAction } from './actions';

// map state to props
const mapStateToProps = (state) => {
  const { stage } = state.loginInfo;
  const { emailOrPhoneValue } = state.forgotUsernameInfo;
  return {
    stage,
    emailOrPhoneValue,
    intl: state.intl,
  };
};

// map dispatch to props
export const mapDispatchToProps = (dispatch) => ({
  submitHandler: (payload) => dispatch(submitAsyncEmailAction(payload)),
  resetStageHandler: () => dispatch(resetStageAction()),
});

const ForgotUsernameContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(ForgotUsernameView));
export default ForgotUsernameContainer;
